import React from 'react';
import { Link } from 'react-router-dom';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

type TermsAcceptanceProps = {
  id: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export const TermsAcceptance: React.FC<TermsAcceptanceProps> = ({
  id,
  checked,
  onCheckedChange
}) => {
  return (
    <div className="flex items-center space-x-2">
      <Checkbox 
        id={id} 
        checked={checked}
        onCheckedChange={(checked) => onCheckedChange(checked as boolean)}
      />
      <Label htmlFor={id} className="text-sm">
        Я принимаю{" "}
        <Link to="/terms" className="text-primary hover:underline">
          условия использования
        </Link>
        {" "}и{" "}
        <Link to="/privacy" className="text-primary hover:underline">
          политику конфиденциальности
        </Link>
      </Label>
    </div>
  );
};
